import React, { useEffect, useState } from 'react';
import './TourSearchPage.scss';
import { Link } from "react-router-dom";

export function TourSearchPage() {
    const [iframeHeight, setIframeHeight] = useState('10px');  // Default height

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data.frameHeight) {
                setIframeHeight(`${event.data.frameHeight}px`);
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    return (
        <div className='tours-search'>
            <iframe
                scrolling={'no'}
                className='tours-iframe'
                src='/tours-search-iframe.html'
                style={{ width: '100%', height: iframeHeight, border: 'none', background: 'white' }}
                title='Tours search'
            ></iframe>
            <Link to={'/pay'}>
                <div className='tours-search-pay'>
                    <img
                        className='tours-search-pay-img'
                        src={require(`../assets/pay-logo.png`)}
                        alt='logo'
                    />
                </div>
            </Link>
        </div>
    )
        ;
}
